import camelcase from 'camelcase';

export function all(iterable) {
  const retval = iterable.reduce((memo, value) => {
    return memo && !!value;
  }, true);
  return retval && ((iterable.size) ? !!iterable.size : !!iterable.length);
}

export function any(iterable) {
  const retval = iterable.reduce((memo, value) => {
    return memo || !!value;
  }, false);
  return retval && ((iterable.size) ? !!iterable.size : !!iterable.length);
}

export function values(obj) {
  return Object.keys(obj).map((key) => obj[key]);
}

export function arrayize(obj) {
  if (!obj) {
    return [];
  }

  return (Array.isArray(obj)) ? obj : [obj];
}

export function camelCast(attributes) {
  return Object.keys(attributes).map((key) => {
    return [camelcase(key), attributes[key]];
  });
}

export function getOrSetArray(subject, type) {
  if (!subject[type]) {
    subject[type] = [];  // eslint-disable-line no-param-reassign
  }
  return subject[type];
}

export function isArrayOfStrings(subject) {
  let value = true;

  if (!Array.isArray(subject)) {
    value = false;
  } else {
    for (const elem of subject) {
      if (typeof elem !== "string") {
        value = false;
      }
    }
  }

  return value;
}



// WEBPACK FOOTER //
// ./app/javascript/requests/utils.js